export default __webpack_public_path__ + "static/O0182-ee398cdf9c0f81d367bf0ed5ee73fb97.png";